import { AlertGroup, AlertKey, SuppressionResponse } from './core/type';
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

// Alert store implementation
interface AlertState {
  unReadCount: number;
  fetched: boolean;
  initUnReadCount: number;
  alertGroup: AlertGroup;
  refreshTimestamp: number;
  total: number;
  alertSuppressionItems: SuppressionResponse[];
}

interface AlertStore {
  state: AlertState;
  setState: (payload: Partial<AlertState>) => void;
  onChangeReadAlert: (id: number) => void;
  onMarkAllRead: () => void;
}

const initAlertState: AlertState = {
  unReadCount: 0,
  fetched: false,
  initUnReadCount: 0,
  total: 0,
  alertGroup: {
    ['Rack Failed Connection']: { total: 0, items: [] },
    ['Reach Critical Level']: { total: 0, items: [] },
    ['Abnormal Consumption']: { total: 0, items: [] },
    ['Shelf Expiry']: { total: 0, items: [] },
  },
  refreshTimestamp: 0,
  alertSuppressionItems: [],
};

export const useAlertStore = create<AlertStore>()(
  immer((set) => ({
    state: initAlertState,
    setState: (payload) => {
      set((store) => {
        store.state = { ...store.state, ...payload };
      });
    },
    onChangeReadAlert: (id) => {
      set((store) => {
        Object.entries(store.state.alertGroup).forEach(([key, alerts]) => {
          store.state.alertGroup[key as AlertKey] = {
            ...alerts,
            items: alerts.items.map((alert) =>
              alert.id === id ? { ...alert, is_read: true } : alert,
            ),
          };
        });

        store.state.unReadCount = Math.max(0, store.state.unReadCount - 1);
      });
    },

    onMarkAllRead: () => {
      set((store) => {
        Object.entries(store.state.alertGroup).forEach(([key, alerts]) => {
          store.state.alertGroup[key as AlertKey] = {
            ...alerts,
            items: alerts.items.map((alert) => ({
              ...alert,
              is_read: true,
            })),
          };
        });

        store.state.unReadCount = 0;
      });
    },
  })),
);
